import { LOCAL_STORAGE_KEYS } from '@constants'

const DEFAULT_CUTOFF_TIME = '19:00'

const isValidCutoffTime = (value?: string | null): value is string =>
  !!value && /^([01]\d|2[0-3]):[0-5]\d$/.test(value)

const getCutoffTime = () => {
  const value = window.localStorage.getItem(LOCAL_STORAGE_KEYS.CUTOFF_TIME)
  return isValidCutoffTime(value) ? value : DEFAULT_CUTOFF_TIME
}

const setCutoffTime = (value: string) => {
  if (!isValidCutoffTime(value)) return
  window.localStorage.setItem(LOCAL_STORAGE_KEYS.CUTOFF_TIME, value)
}

const applyCutoffTimeToDate = (date: Date, cutoffTime: string) => {
  const [hour, minute] = cutoffTime.split(':').map(Number)
  const nextDate = new Date(date)
  nextDate.setHours(hour, minute, 0, 0)
  return nextDate
}

const isDateBefore24HoursThreshold = (date: Date, cutoffTime: string) => {
  const dateWithCutoff = applyCutoffTimeToDate(date, cutoffTime)
  const threshold = new Date()
  threshold.setHours(threshold.getHours() + 24)
  return dateWithCutoff.getTime() < threshold.getTime()
}

export const CutoffTimeUtils = {
  DEFAULT_CUTOFF_TIME,
  getCutoffTime,
  setCutoffTime,
  applyCutoffTimeToDate,
  isDateBefore24HoursThreshold,
}
